// A signed-in OWNER whose business identity still has no name — every owner
// made before the «ما اسمك؟» step existed (ihjizli-profile
// GET /v1/business/me/identity → full_name ''): open /onboarding/you ONCE per
// page load, carrying where they were going, and the screen sends them back
// there once the name is saved. Owners only (a member's name comes with the
// invite); online only (an intranet node has no web onboarding). The shell
// renders meanwhile and the check fails OPEN: an identity read that errors
// (older profile, offline) never traps anyone behind the question.

import { useEffect, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchIdentityName, IDENTITY_KEY, ONB, onboardingAvailable } from '@/features/onboarding';
import { useErp } from './erp-context';

/** Asked this page load already — the question is put once, never in a loop. */
let asked = false;

/** Tests: the next gate may ask again. */
export function resetOwnerNameGate(): void {
  asked = false;
}

export function OwnerNameGate({ children }: { children: ReactNode }) {
  const { role } = useErp();
  const navigate = useNavigate();
  const location = useLocation();
  const enabled = role === 'owner' && onboardingAvailable();
  const identity = useQuery({ queryKey: IDENTITY_KEY, queryFn: fetchIdentityName, enabled, retry: 0, staleTime: 5 * 60_000 });
  const missing = enabled && identity.isSuccess && identity.data === '';

  useEffect(() => {
    if (!missing || asked) return;
    asked = true;
    navigate(ONB.you, { state: { then: `${location.pathname}${location.search}` } });
    // `location` is read once, at the moment the question is put.
  }, [missing, navigate]);

  return <>{children}</>;
}
